import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import ClearIcon from '@mui/icons-material/Clear';
import { useDisapproveDropshippingCompanyRequestsMutation } from '../../../../../../../graphql/mutation/dropshippingRequestCompany/disapproveDropshippingCompanyRequestsMutation';
import ButtonSubmit from '../../../../../../components/_button/ButtonSubmit';
import useNotification from '../../../../../../components/_hook/useNotification';

interface IProps {
  requestIds: string[];
  onSuccess?: () => void;
  component?: (onClickDisapprove: () => void) => ReactElement;
  fullWidth?: boolean;
  size?: 'small' | 'medium' | 'large';
}

export default function ButtonDisapproveDropshipper(props: IProps) {
  const { t } = useTranslation();
  const { notification } = useNotification();
  const { requestIds, onSuccess, component, size, fullWidth } = props;

  const [
    disapproveDropshippingCompanyMutation,
    { loading: isDisapprovingDropshippingCompany },
  ] = useDisapproveDropshippingCompanyRequestsMutation(
    `updatedDropshippingCompanyRequests {
				_id
				status
			}`,
    {
      onCompleted: () => {
        notification.success(
          t('__item___updated', {
            item: `${requestIds.length} ${t('company', {
              count: requestIds.length,
            })}`,
          })
        );
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: (e) => {
        notification.error(e.message);
      },
    }
  );

  async function onClickDisapprove() {
    await disapproveDropshippingCompanyMutation({
      variables: { _ids: requestIds },
    });
  }

  if (component) {
    return component(onClickDisapprove);
  }

  return (
    <ButtonSubmit
      iconPosition="left"
      size={size}
      fullWidth={fullWidth}
      variant="contained"
      useButtonDanger
      onClick={onClickDisapprove}
      isSubmitting={isDisapprovingDropshippingCompany}
      label={t('disapprove')}
      icon={<ClearIcon />}
    />
  );
}
